const state = {
  data: [],
  item: {},
  latest: [],
  isPending: false,
};

export default state;
